"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _TouchableWithoutFeedback = _interopRequireDefault(require("react-native-web/dist/cjs/exports/TouchableWithoutFeedback"));
var _dictionary = _interopRequireDefault(require("./dictionary"));
var _utils = require("../utils");
var _ThemeProvider = require("../ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.htmlAttrs, _utils.viewProps]);

// The top property varies between devices due to how devices render the viewport.
const selectTextStyle = _ref => {
  let {
    fontSize,
    lineHeight
  } = _ref;
  return {
    fontSize,
    lineHeight: lineHeight !== 1 ? lineHeight : fontSize * 2,
    ..._Platform.default.select({
      ios: {
        top: -fontSize / 2
      },
      android: {
        top: fontSize / 4
      },
      web: {
        top: -fontSize / 2.8
      }
    })
  };
};
const FootnoteLink = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    copy = 'en',
    content = [],
    onClick,
    tokens,
    variant = {},
    ...rest
  } = _ref2;
  const themeTokens = (0, _ThemeProvider.useThemeTokens)('FootnoteLink', tokens, variant);
  const textStyles = (0, _ThemeProvider.applyTextStyles)(themeTokens);
  const numbers = Array.isArray(content) ? content : [content];
  const refs = numbers.map(() => /*#__PURE__*/_react.default.createRef());
  const handleOnClick = index => {
    onClick(numbers[index], refs[index]);
  };
  const getCopy = (0, _utils.useCopy)({
    dictionary: _dictionary.default,
    copy
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
    ref: ref,
    style: staticStyles.container,
    children: numbers.map((num, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
      accessibilityLabel: getCopy('a11yLabel'),
      ref: refs[index],
      ...selectProps(rest),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TouchableWithoutFeedback.default, {
        onPress: handleOnClick,
        accessibilityRole: "button",
        children: (0, _utils.wrapStringsInText)(`${num}${index !== numbers.length - 1 ? ',' : ''}`, {
          style: {
            ...textStyles,
            ...staticStyles.text,
            ...selectTextStyle(themeTokens)
          }
        })
      })
    }, num))
  });
});
FootnoteLink.displayName = 'FootnoteLink';
const copyShape = _propTypes.default.shape({
  a11yLabel: _propTypes.default.string.isRequired
});
FootnoteLink.propTypes = {
  ...selectedSystemPropTypes,
  variant: _utils.variantProp.propType,
  /**
   * Use the `copy` prop to either select provided English or French copy by passing 'en' or 'fr' respectively.
   * To provide your own, pass a JSON object with the key `a11yLabel`.
   */
  copy: _propTypes.default.oneOfType([_propTypes.default.oneOf(['en', 'fr']), copyShape]),
  /**
   * The footnote number, or multiple numbers if passed as an array.
   * If using an array, a comma-separated group of numbers will be rendered as superscript.
   */
  content: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number), _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]).isRequired,
  /**
   * A callback function to handle the click of a FootnoteLink.
   */
  onClick: _propTypes.default.func.isRequired
};
var _default = exports.default = FootnoteLink;
const staticStyles = _StyleSheet.default.create({
  text: {
    position: 'relative',
    textDecorationLine: 'underline'
  },
  container: {
    flexDirection: 'row'
  }
});